// extracted by mini-css-extract-plugin
module.exports = {"sponsoredBanner":"Fj-z","sponsoredTooltipWrapper":"Gj-z","sponsoredTooltip":"Hj-z","newCard":"Ij-z"};